angular.module('homebot.directives')

.directive('yourLoansSentence', ['Dictionary', '$filter', function(Dictionary, $filter){
  return {
    restrict: 'A',
    controllerAs: 'sentenceCtrl',
    bindToController: {
      loans: '=',
      long: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/your-loans-sentence.html',

    controller: function(){
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function(prop,args,home){
        var home = {loans: ctrl.loans};
        return dictionary[prop](home,args);
      };

      ctrl.loanAmounts = function(){
        return _.map(_.pluck(ctrl.loans, 'amount'), function(amount){
            return $filter('money')(amount);
          }).join(' and ');
      };
    }
  }
}]);
